import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFolderOpen, faLock } from "@fortawesome/free-solid-svg-icons"
import { tableStyles } from "../styles/tableStyles"
import { COLORS } from "../../utilities/Constants"

// Cellule N° des TROIS tableaux de résultats (dépannage / atelier / location).
// Décision Jordan 31.07.2026 : toutes les icônes de statut vivent ici, à côté
// du numéro — plus rien devant le nom du client, plus aucun fond de ligne
// porteur de sens (le zébrage et le hover redeviennent la seule couleur des
// lignes).
//
// Ordre imposé, identique partout : numéro, dossier vert, cadenas, puis les
// statuts propres au domaine (passés en `children` : triangle client
// incomplet, pastille reste à payer, icône prêt…). Le composant EST la
// définition de cet ordre : les pages n'ont plus à s'accorder entre elles.
export const RESULT_ICON_SIZE = 11

const ResultNumCell = ({ index, isOpen, lockedBy, children }) => (
	<td style={styles.td}>
		<span style={styles.inner}>
			{index + 1}
			{/* Dossier vert : « dernière fiche visitée », pas « ouverte
			    maintenant » — l'id survit à la sortie de fiche (c'est lui qui
			    dégrise le bouton nav « Fiche »). Le verrou, c'est le cadenas. */}
			{isOpen && (
				<FontAwesomeIcon
					icon={faFolderOpen}
					title="Dernière fiche consultée"
					style={{ color: COLORS.success, fontSize: RESULT_ICON_SIZE }}
				/>
			)}
			{lockedBy && (
				<FontAwesomeIcon
					icon={faLock}
					title={`Verrouillée par ${lockedBy}`}
					style={{ color: COLORS.gold, fontSize: RESULT_ICON_SIZE }}
				/>
			)}
			{children}
		</span>
	</td>
)

const styles = {
	td: {
		...tableStyles.td,
		fontVariantNumeric: "tabular-nums",
	},
	inner: {
		display: "inline-flex",
		alignItems: "center",
		gap: 6,
	},
}

export default ResultNumCell
